import { Surface } from '@payments-checkout/shared/components';
import jadeTheme from '@stone-payments/jade-design-tokens/cjs/stone';
import styled from 'styled-components';

export const SummaryTable = styled(Surface)<{ removeBorderRadiusTop?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${jadeTheme.global.space[100]};
  ${({ removeBorderRadiusTop }) =>
    removeBorderRadiusTop ? 'border-top-left-radius: 0; border-top-right-radius: 0;' : ''}
`;

export const SummaryItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: ${jadeTheme.global.space[100]};
  padding-bottom: ${jadeTheme.global.space[100]};
`;

export const TriggerContainer = styled(Surface)`
  display: flex;
  justify-content: space-between;
`;

export const DetailText = styled.div`
  display: flex;
  gap: ${jadeTheme.global.space[50]};
`;
